'use memo';

import { createFileRoute, useParams } from '@tanstack/react-router';
import { useMemo } from 'react';
import { FillScreen } from '@/components/Layout';
import { Loader } from '@/components/Loading/Loader';
import { Text } from '@/components/Typography/Text';
import { useGetOperationPackageConfigs } from '@/features/operation-package-config-new/PackagePatternConfig/-query';
import { findPatternInConfigRows, isDraftOnlyPattern, shouldUseInHouseDraftEditor } from '@/features/operation-package-config-new/PackagePatternConfig/-utils/findPatternInConfigRows';
import { PackagePatternConfigDetail } from '@/features/operation-package-config-new/PackagePatternDetail';
import { PackagePatternDraftConfig } from '@/features/operation-package-config-new/PackagePatternDraftConfig';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { useItOperationCoreEligibleTargetSlot } from './-hooks/useItOperationCoreEligibleTargetSlot';
export const Route = createFileRoute('/_staff/it-operation-core/config/$patternId/')({
  component: PatternConfigPage
});
function PatternConfigPage() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.itOperationCore'
  });
  const {
    patternId
  } = useParams({
    from: '/_staff/it-operation-core/config/$patternId/'
  });
  const {
    data: configRows,
    isFetching: isConfigsFetching
  } = useGetOperationPackageConfigs('IT_OPERATION_CORE');
  const patternContext = useMemo(() => findPatternInConfigRows(configRows ?? [], patternId), [configRows, patternId]);
  const useInHouseDraftEditor = patternContext !== null && shouldUseInHouseDraftEditor(patternContext);
  const isDraftOnly = patternContext !== null && isDraftOnlyPattern(patternContext);
  const eligibleTargetSlot = useItOperationCoreEligibleTargetSlot(patternId, {
    enabled: !isConfigsFetching && patternContext !== null && !useInHouseDraftEditor && !isDraftOnly
  });
  if (isConfigsFetching) {
    return <FillScreen className="flex items-center justify-center">
        <Loader />
      </FillScreen>;
  }
  if (useInHouseDraftEditor && patternContext) {
    return <PackagePatternDraftConfig ownerProduct="IT_OPERATION_CORE" packageId={patternContext.packageId} patternId={patternId} configListHref="/it-operation-core/config" configListLabel={t('title')} />;
  }
  if (isDraftOnly) {
    return <FillScreen className="flex items-center justify-center px-12">
        <Text variant="p" className="text-neutral-muted-on-fill">
          {t('inHousePackages.selfReportPatternConfig.statusDraft')}
        </Text>
      </FillScreen>;
  }
  return <PackagePatternConfigDetail ownerProduct="IT_OPERATION_CORE" patternId={patternId} breadcrumbs={[{
    linkTo: '/it-operation-core/config',
    label: t('title')
  }]} eligibleTargetSlot={eligibleTargetSlot} />;
}